import(/* webpackMode: "eager" */ "/home/interim/frontend/app/reliability/page.tsx");
